export interface RedirectEntriesProps {
  from: string;
  to: string;
  redirectStatusCode: 'permanent-301' | 'temporary-302';
}

export interface RedirectsProps {
  redirects: RedirectEntriesProps[];
}
import { nextApiEndpoint } from '@/constant/env';
import { withStrapiHeaders } from '@/utils/fetch';

import { Logger } from './Logging';

export const getRedirectsFromStrapi = async () => {
  const logger = new Logger('getRedirectsFromStrapi');
  try {
    const STRAPI_API_URL = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/redirect?populate=redirects&locale=${process.env.NEXT_PUBLIC_LOCALE}`;

    const res = await fetch(STRAPI_API_URL, {
      headers: withStrapiHeaders({
        'Strapi-Response-Format': 'v5',
      }),
      next: { revalidate: 60, tags: ['redirects'] },
    });

    const data = await res.json();

    return (data.data?.redirects ?? []).map((entry: any) => ({
      from: entry.from || '',
      to: entry.to || '',
      redirectStatusCode:
        entry.redirectStatusCode === 'permanent-301' ||
        entry.redirectStatusCode === 'temporary-302'
          ? entry.redirectStatusCode
          : 'permanent-301',
    }));
  } catch (error) {
    logger.error({
      context: error,
      message: 'Error fetching redirects from Strapi',
    });
    return [];
  }
};

export const getRedirectsFromNextApi = async () => {
  const res = await fetch(`${nextApiEndpoint}/redirect`);

  const data = await res.json();
  return data;
};
